import { atom } from "nanostores";

export const $activeSurveySection = atom<string>("");
export const $surveySections = atom<string[]>([]);
